import ArrowBack from "@material-symbols/svg-400/outlined/arrow_back.svg";
import Info from "@material-symbols/svg-400/outlined/info-fill.svg";
import Error from "@material-symbols/svg-400/outlined/error.svg";
import Block from "@material-symbols/svg-400/outlined/block.svg";
import CheckCircle from "@material-symbols/svg-400/outlined/check_circle-fill.svg";
import Visibility from "@material-symbols/svg-400/outlined/visibility.svg";
import VisibilityOff from "@material-symbols/svg-400/outlined/visibility_off.svg";
import DarkMode from "@material-symbols/svg-400/outlined/dark_mode.svg";
import LightMode from "@material-symbols/svg-400/outlined/light_mode.svg";
import ProgressActivity from "@material-symbols/svg-400/outlined/progress_activity.svg";
import {
  FileTextIcon,
  XIcon,
  MinusIcon,
  CheckIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  ChevronRightIcon,
  ChevronLeftIcon,
  PencilIcon,
  PlusIcon,
  Trash2Icon,
} from "lucide-react";
import { cn } from "@/lib/utils";

import ArrowForwardIOS_SVG from "@material-symbols/svg-400/rounded/arrow_forward_ios.svg";
import ArrowBackIOS_SVG from "@material-symbols/svg-400/rounded/arrow_back_ios.svg";

import Leaderboard from "@material-symbols/svg-400/rounded/leaderboard-fill.svg";
import Group from "@material-symbols/svg-400/rounded/group-fill.svg";
import Store from "@material-symbols/svg-400/rounded/store-fill.svg";
import ManageAccounts from "@material-symbols/svg-400/rounded/manage_accounts-fill.svg";
import Home from "@material-symbols/svg-400/rounded/home-fill.svg";
import Language from "@material-symbols/svg-400/rounded/language-fill.svg";
import Newsmode from "@material-symbols/svg-400/rounded/newsmode-fill.svg";
import Newspaper from "@material-symbols/svg-400/outlined/newspaper.svg";
import Key_SVG from "@material-symbols/svg-400/rounded/key-fill.svg";
import Copy_SVG from "@material-symbols/svg-400/rounded/content_copy.svg";

import HelpSVG from "@material-symbols/svg-400/rounded/help.svg";
import HintSVG from "@material-symbols/svg-400/rounded/lightbulb.svg";
import ChatBubbleOutlineSVG from "@material-symbols/svg-400/outlined/chat_bubble.svg";
import NotificationsSVG from "@material-symbols/svg-400/rounded/notifications.svg";
import CloseSVG from "@material-symbols/svg-400/rounded/close.svg";
import DeleteSVG from "@material-symbols/svg-400/outlined/delete_forever.svg";
import NewsCalendarSVG from "@material-symbols/svg-400/rounded/calendar_month.svg";
import NewsTranslateSVG from "@material-symbols/svg-400/rounded/translate.svg";
import NewsSearchSVG from "@material-symbols/svg-400/rounded/search.svg";
import NewsImageSVG from "@material-symbols/svg-400/rounded/image.svg";
import NewsAddPhotoSVG from "@material-symbols/svg-400/rounded/add_photo_alternate.svg";
import NewsPreviewSVG from "@material-symbols/svg-400/rounded/visibility.svg";
import NewsArchiveSVG from "@material-symbols/svg-400/rounded/archive.svg";
import NewsRestoreSVG from "@material-symbols/svg-400/rounded/unarchive.svg";
import NewsShareSVG from "@material-symbols/svg-400/rounded/ios_share.svg";
import NewsStarSVG from "@material-symbols/svg-400/rounded/star-fill.svg";
import DoneSVG from "@material-symbols/svg-400/rounded/check.svg";
import DoneAllSVG from "@material-symbols/svg-400/rounded/done_all.svg";
import OpenInNewSVG from "@material-symbols/svg-400/rounded/open_in_new.svg";

import ShieldBad from "@material-symbols/svg-400/rounded/gpp_bad.svg";
import ShieldGood from "@material-symbols/svg-400/rounded/shield.svg";

import { IconWrap } from "./Base";

// Simple SVG component exports
export { ArrowBack };
export { Info };
export { Error };
export { Block };
export { CheckCircle };
export { Visibility };
export { VisibilityOff };
export { DarkMode };
export { LightMode };
export { ProgressActivity };

// Lucide re-exports
export {
  XIcon,
  MinusIcon,
  CheckIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  ChevronRightIcon,
  ChevronLeftIcon,
};

// Wrapped components
export const Dashboard = ({ className = "" }) => (
  <IconWrap className={className}>
    <Leaderboard className="[fill:currentColor] text-commerce-01 w-6 h-6" />
  </IconWrap>
);

export const Marketplace = ({ className = "" }) => (
  <Store className={cn("[fill:currentColor] w-6 h-6", className)} />
);

export const Users = ({ className = "" }) => (
  <Group className={cn("[fill:currentColor] w-6 h-6", className)} />
);

export const AdminUsers = ({ className = "" }) => (
  <ManageAccounts className={cn("[fill:currentColor] w-7 h-7", className)} />
);

export const Company = ({ className = "" }) => (
  <Home className={cn("[fill:currentColor] w-6 h-6", className)} />
);
export const Translation = ({ className = "" }) => (
  <Language className={cn("[fill:currentColor] w-6 h-6", className)} />
);

export const Logs = ({ className = "" }) => (
  <Newsmode className={cn("[fill:currentColor] w-6 h-6", className)} />
);

export const News = ({ className = "" }) => (
  <Newspaper className={cn("[fill:currentColor] w-6 h-6", className)} />
);

export const Key = ({ className = "" }) => (
  <Key_SVG className={cn("[fill:currentColor] w-6 h-6", className)} />
);

export const Question = ({ className = "" }) => (
  <HelpSVG
    className={cn("[fill:currentColor] text-commerce-10 w-6 h-6", className)}
  />
);

export const Hint = ({ className = "" }) => (
  <HintSVG className={cn("[fill:currentColor]", className)} />
);

export const ChatBubbleOutline = ({ className = "" }) => (
  <ChatBubbleOutlineSVG
    className={cn("[fill:currentColor] text-commerce-10 w-6 h-6", className)}
  />
);

export const Notifications = ({ className = "" }) => (
  <NotificationsSVG
    className={cn("[fill:currentColor] text-commerce-10 w-6 h-6", className)}
  />
);

export const Close = ({ className = "" }) => (
  <CloseSVG className={cn("[fill:currentColor] text-commerce-10", className)} />
);

export const Delete = ({ className = "" }) => (
  <DeleteSVG
    className={cn("[fill:currentColor] text-commerce-10", className)}
  />
);

export const Done = ({ className = "" }) => (
  <DoneSVG className={cn("[fill:currentColor] text-commerce-10", className)} />
);

export const DoneAll = ({ className = "" }) => (
  <DoneAllSVG
    className={cn("[fill:currentColor] text-commerce-10", className)}
  />
);

export const OpenInNew = ({ className = "" }) => (
  <OpenInNewSVG
    className={cn("[fill:currentColor] text-commerce-10", className)}
  />
);

export const ArrowForwardIOS = ({ className = "" }) => (
  <ArrowForwardIOS_SVG
    className={cn("[fill:currentColor] text-commerce-10 w-4 h-4", className)}
  />
);

export const ArrowBackIOS = ({ className = "" }) => (
  <ArrowBackIOS_SVG
    className={cn("[fill:currentColor] text-commerce-10 w-4 h-4", className)}
  />
);

export const Green2FA = ({ className = "" }) => (
  <ShieldGood
    className={cn("[fill:currentColor] w-8 h-8 text-commerce-green", className)}
  />
);

export const Red2FA = ({ className = "" }) => (
  <ShieldBad
    className={cn("[fill:currentColor] w-8 h-8 text-commerce-red", className)}
  />
);

export const Copy = ({ className = "" }) => (
  <Copy_SVG
    className={cn("[fill:currentColor] text-commerce-10 w-6 h-6", className)}
  />
);

export const NewsCalendar = ({ className = "" }) => (
  <NewsCalendarSVG className={cn("[fill:currentColor] w-6 h-6", className)} />
);

export const NewsTranslate = ({ className = "" }) => (
  <NewsTranslateSVG className={cn("[fill:currentColor] w-6 h-6", className)} />
);

export const NewsSearch = ({ className = "" }) => (
  <NewsSearchSVG className={cn("[fill:currentColor] w-6 h-6", className)} />
);

export const NewsImage = ({ className = "" }) => (
  <NewsImageSVG className={cn("[fill:currentColor] w-6 h-6", className)} />
);

export const NewsAddPhoto = ({ className = "" }) => (
  <NewsAddPhotoSVG className={cn("[fill:currentColor] w-6 h-6", className)} />
);

export const NewsDelete = ({ className = "" }) => (
  <Trash2Icon className={cn("w-6 h-6", className)} />
);

export const NewsAdd = ({ className = "" }) => (
  <PlusIcon className={cn("w-6 h-6", className)} />
);

export const NewsEdit = ({ className = "" }) => (
  <PencilIcon className={cn("w-6 h-6", className)} />
);

export const NewsPreview = ({ className = "" }) => (
  <NewsPreviewSVG className={cn("[fill:currentColor] w-6 h-6", className)} />
);

export const NewsArchive = ({ className = "" }) => (
  <NewsArchiveSVG className={cn("[fill:currentColor] w-6 h-6", className)} />
);

export const NewsRestore = ({ className = "" }) => (
  <NewsRestoreSVG className={cn("[fill:currentColor] w-6 h-6", className)} />
);

export const NewsShare = ({ className = "" }) => (
  <NewsShareSVG className={cn("[fill:currentColor] w-6 h-6", className)} />
);

export const NewsStar = ({ className = "" }) => (
  <NewsStarSVG className={cn("[fill:currentColor] w-6 h-6", className)} />
);
